import React, { useState,useRef } from 'react'
import { Input, Drawer, message,Divider,Button,Empty,Icon } from 'antd'
import { useRequest } from 'ahooks'
import { itemSearch } from '../service'
import _ from 'lodash'
import styles from './ProductSearchbar.module.less'
import PropTypes from 'prop-types'
import SearchProductItem from './SearchProductItem'
import FilterBar from './FilterBar'
import common from '@/public/common'
import {qwWxShareFn} from '../utils'
const { Search } = Input

function ProductSearchbar(props) {
  const {brandName, brandId} = props
  const defaultPageObj = { page_size: 10, page_index: 0 }
  const [keyword, setKeyword] = useState('')
  const [visible, setVisible] = useState(false)
  const [ifhasMore, setIfHasMore] = useState(false)
  const [pageParams, setPageParams] = useState({ ...defaultPageObj, keyword: '' })
  const [productData, setProductData] = useState([])
  const [aggsData, setAggsData] = useState({})
  const [searchGoodTotal, setSearchGoodTotal] = useState(0)
  const [aggsDrawer, setAggsDrawer] = useState(false) 
  const must = useRef([])
  const selectFilterObj = useRef({})


  const getResetParams = (obj) => {
    const _parmas = _.cloneDeep(pageParams)
    const _p = { ..._parmas, ...defaultPageObj, ...obj }
    return _p
  }
  const {
    run: fetchItemSearch,
    loading: itemSearchLoading
  } = useRequest(({ params }) => {
    let data = params
    data.filter = {
      must: must.current || [],
      must_not: [],
      should: []
    }
    data.brand_id = brandId
    return itemSearch(data)
  },
    {
      manual: true,
      onBefore: () => {
      },
      onSuccess: (res, params) => {
        console.log('res', res)
        const list = res.hits.list || []
        const total = res.hits.total || 0
        const aggs = res.aggs || {}
        setSearchGoodTotal(total)
        setAggsData(aggs)
        const ifLoad = params[0].ifLoad
        if (list) {
          setVisible(true)
          setIfHasMore(list.length == pageParams.page_size)
          if (ifLoad) {
            setProductData((_data) => {
              return [..._data, ...list]
            })
          } else {
            setProductData(list)
          }
        } else {
          message.error('暂无商品')
          // setVisible(false)
          setIfHasMore(false)
          if (ifLoad) {
          } else {
            setProductData([])
          }
        }
      },
      onFinally:(params)=>{
        if(params[0].params.page_index==0){
          const _dom = document.querySelector('#ProductSearchbar-Drawer .ant-drawer-content-wrapper .ant-drawer-wrapper-body')
          _dom.scrollTo(0,0)
        }
      }
    },
  );
  const searchFn = (v) => {
    if (_.trim(v)) {
      must.current = []
      selectFilterObj.current = {}
      const _p = { ...getResetParams({ page_index: 0, keyword: v }) }
      setPageParams(_p)
      fetchItemSearch({ params: _p, ifLoad: false })
    }
  }
  const onClose = () => {
    setVisible(false)
  }
  const loadMore = () => {
    const _params = {...getResetParams({page_index: pageParams.page_index + 1})}
    setPageParams(_params)
    fetchItemSearch({ params: _params, ifLoad: true })
  }

  const openAggsDrawer = (visible) => {
    setAggsDrawer(visible)
  }

  const onSelectFilter = ({ query, key, parkey, gte, lt }) => {
    // 所选筛选条件对象
    let tempMustArr = []
    /** @type {object} */
    let _selectFilterObj = _.cloneDeep(selectFilterObj.current)
    const _spacialArrKey = _.get(aggsData, 'aggs.special.buckets', []).map(ele => ele.agg_key)
    if (query === 'terms') {
      // 筛选对象赋值
      // 若不存在则创建为空数组
      if (!_selectFilterObj[parkey]) {
        _selectFilterObj[parkey] = []
      }
      // 若存在则删除
      if (_selectFilterObj[parkey].includes(key)) {
        const _delkey = _selectFilterObj[parkey].indexOf(key)
        _selectFilterObj[parkey].splice(_delkey, 1)
        if (_selectFilterObj[parkey].length === 0) {
          delete _selectFilterObj[parkey]
        }
      } else {
        // 数组的需要点击单个元素就上报一下点击
        _selectFilterObj[parkey].push(key)
      }
    } else if (query === 'range') {
      _selectFilterObj[parkey] = {
        gte: parseFloat(gte),
        lt: parseFloat(lt)
      }
    } else {
      //  如果是特定的，就针对特定的单选
      if (_spacialArrKey.includes(parkey)) {
        //  如果已经选择了，则取消选择
        if (_selectFilterObj[parkey]) {
          delete _selectFilterObj[parkey]
        }
        //  如果没有选择，则删除所有的spacial的key再去添加
        else {
          for (let keys in _spacialArrKey) {
            delete _selectFilterObj[_spacialArrKey[keys]]
          }
          _selectFilterObj[parkey] = key
        }
      } else {
        _selectFilterObj[parkey] = key
      }
    }
    // 根据所选对象转换为传值的数据
    for (let _key in _selectFilterObj) {
      let _obj = {}
      if (Object.prototype.hasOwnProperty.call(_selectFilterObj, _key)) {
        if (Array.isArray(_selectFilterObj[_key]) && _selectFilterObj[_key].length > 0) {
          _obj.terms = {
            [_key]: _selectFilterObj[_key]
          }
        } else if (_key.indexOf('price') >= 0 || _key.indexOf('capacity') >= 0) {
          _obj.range = {
            [_key]: _selectFilterObj[_key]
          }
        } else {
          _obj.term = {
            [_key]: _selectFilterObj[_key]
          }
        }
        tempMustArr.push(_obj)
      }
    }
    must.current = tempMustArr || []
    selectFilterObj.current = _selectFilterObj || {}
    const _params = {...getResetParams({page_index: 0})}
    setPageParams(_params)
    fetchItemSearch({ params: _params, ifLoad: false })
  }

  const onResetFilter = () => {
    must.current = []
    selectFilterObj.current = {}
    const _params = {...getResetParams({page_index: 0})}
    setPageParams(_params)
    fetchItemSearch({ params: _params, ifLoad: false })
  }

  // 发送链接
  const sendSearchMustGoodsLink = () => {    
    const _params = getResetParams({})
    const keyword = _params.keyword || ''
    let imgUrl = 'https://s1.vsigo.cn/images/logo.png'
    if (productData && productData.length > 0) {
      const item = productData[0]
      if (item.image) {
        imgUrl = item.image
      }
    }
    const _link = `/pages/search/search.html?keyWords=${keyword}&filt_must_json=${JSON.stringify(must.current || [])}`
    const _webUrl = `${common.m_main_url}Search-${keyword}-----1.html?filt_must_json=${JSON.stringify(must.current || [])}`    
    qwWxShareFn({
      title: '亲，为您推荐商品如下',
      imgUrl: imgUrl.replace(/\/\d+-\d+\//g, '/500-500/'),
      link: _link,
      brandName: brandName,
      webUrl: _webUrl
    })
  }

  const searchDom = (
    <Search placeholder='输入商品名称' loading={itemSearchLoading} value={keyword} allowClear onChange={(e) => { setKeyword(e.target.value) }} onSearch={searchFn}></Search>
  )

  // if(!source_channel){
  //   return null
  // }
  return (
    <div className={styles.ProductSearchbar} >
      {searchDom}
      <Drawer
        id='ProductSearchbar-Drawer'
        height={600}
        style={{width:335}}
        placement={'top'}
        onClose={onClose}
        visible={visible}
        title="商品搜索"
        maskClosable={true}
        className={styles.ProductSearchbarDrawer}
      >
        <div className={styles.searchWrap}>
          {searchDom}
          {productData.length ? <div className='fl-row-right' style={{ flex: 1, marginTop: 10 }}>
            <div style={{ marginRight: '8px', cursor: 'pointer' }} onClick={() => { openAggsDrawer(true) }}>
              <span>筛选</span>
              <Icon type="filter" theme="filled" />
            </div>
            <div style={{ marginRight: '8px', cursor: 'pointer', color: '#00B38B' }} onClick={() => { sendSearchMustGoodsLink() }}>发送链接</div>
          </div> : null}
        </div>
        <div className={styles.listWrap}>
          {productData.length?
          productData.map((e,index)=>{
            return (<SearchProductItem brandName={brandName} data={e} key={index}></SearchProductItem>)
          }):<Empty></Empty>}
          {ifhasMore?<Divider><Button onClick={loadMore} type='link'>加载更多</Button></Divider>:<Divider>已经到底了</Divider>}
        </div>
      </Drawer>

      <Drawer
        width={348}
        placement={'left'}
        closable={false}
        visible={aggsDrawer}
        onClose={() => { openAggsDrawer(false) }}
      >
        <FilterBar
          aggsData={aggsData}
          num={searchGoodTotal}
          onSelectFilter={onSelectFilter}
          onResetFn={onResetFilter}
          onSureFN={() => { openAggsDrawer(false) }}
        />
      </Drawer>
    </div>
  )
}

ProductSearchbar.propTypes = {
  brandName:PropTypes.string,
  brandId:PropTypes.string
}

export default ProductSearchbar



// WEBPACK FOOTER //
// ./src/pages/udeskSide/components/ProductSearchBar.js